import { cn } from '@/lib/utils'

interface Props {
  className?: string
  currentStep: number
  totalSteps: number
  stepLabels?: string[]
}

export const Stepper = ({ className, currentStep, totalSteps, stepLabels }: Props) => {
  return (
    <div className={cn('flex items-start gap-2', className)}>
      {Array.from({ length: totalSteps }, (_, index) => (
        <div key={index} className='flex min-w-0 flex-1 flex-col items-center gap-2'>
          <div
            className={cn(
              'h-1 rounded-full',
              index === currentStep ? 'bg-icon-default' : 'bg-button-secondary-border-disabled',
              stepLabels?.length ? 'w-full' : 'w-12'
            )}
          />
          {stepLabels?.[index] ? (
            <span
              className={cn(
                'text-center text-base leading-tight',
                index === currentStep ? 'text-foreground font-medium' : 'text-muted-foreground'
              )}
            >
              {stepLabels[index]}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  )
}
